import { render, staticRenderFns } from "./XReport.vue?vue&type=template&id=6b905ae2&lang=html&"
import script from "./XReport.vue?vue&type=script&lang=js&"
export * from "./XReport.vue?vue&type=script&lang=js&"
import style0 from "./XReport.vue?vue&type=style&index=0&id=6b905ae2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports